import { QuizImportMethods } from '@showbie-socrative/socrative-utils';
import { decamelizeKeys } from 'xcase';

import localAxios from '../../localAxios';
import { extractSocNumber } from '../../utils';
import { importWorkspaceQuizzesBySocURL } from '../workspacesURLs';

interface ImportWorkspaceQuizBySocParams {
  workspaceId: string;
  socNumber: string;
  parentFolderId: string;
}

export function importWorkspaceQuizBySoc({
  workspaceId,
  socNumber,
  parentFolderId,
}: ImportWorkspaceQuizBySocParams) {
  const justNumber = extractSocNumber(socNumber);

  const url = importWorkspaceQuizzesBySocURL({
    workspaceId: workspaceId,
    method: QuizImportMethods.ByCode,
  });

  return localAxios.post(
    url.href,
    decamelizeKeys({ socNumber: justNumber, parentFolderId })
  );
}
